import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SELECT_ENUM, SELECT_LOOKUP, TEXT_FIELD, NUMBER_FIELD, DATE, HIDDEN } from '../InputTypes';

export const fields = [
  'EducationTypeName',
  'EducationHrSchoolName',
  'EducationHrDegreeName',
  'EducationHrBranchOfStudy1Name',
];

export const detailFields = [
  'EducationTypeName',
  'EducationHrSchoolName',
  'EducationHrDegreeName',
  'EducationHrBranchOfStudy1Name',
  'EducationHrBranchOfStudy2Name',
  'EducationPeriodBegda',
  'EducationPeriodEnda',
  'EducationGrade',
  'EducationHighestText',
  'EducationFurtherInfo',
  'EducationCountryName',
];

export const entityMap = {
  EmployeeMasterID: {
    type: HIDDEN,
  },
  EmployeeMasterEducationID: {
    type: HIDDEN,
  },
  EducationGrade: {
    type: NUMBER_FIELD,
  },
  EducationHighest: {
    type: SELECT_ENUM,
    options: [
      { value: false, label: <FormattedMessage id="education.no" /> },
      { value: true, label: <FormattedMessage id="education.yes" /> },
    ],
  },
  EducationHrBranchOfStudy1ID: {
    type: SELECT_LOOKUP,
    lookup: {
      entity: 'HrBranchOfStudy',
      link: 'HrEducationType',
      lookupValue: 'EducationType',
      value: 'HrBranchOfStudyID',
      label: 'HrBranchOfStudyName',
    },
  },
  EducationHrBranchOfStudy2ID: {
    type: SELECT_LOOKUP,
    lookup: {
      entity: 'HrBranchOfStudy',
      link: 'HrEducationType',
      lookupValue: 'EducationType',
      value: 'HrBranchOfStudyID',
      label: 'HrBranchOfStudyName',
    },
  },
  EducationHrDegreeID: {
    type: SELECT_LOOKUP,
    lookup: {
      entity: 'HrDegree',
      link: 'HrEducationType',
      lookupValue: 'EducationType',
      value: 'HrDegreeID',
      label: 'HrDegreeName',
    },
  },
  EducationHrSchoolID: {
    type: SELECT_LOOKUP,
    lookup: {
      entity: 'HrSchool',
      link: 'HrEducationType',
      lookupValue: 'EducationType',
      value: 'HrSchoolID',
      label: 'HrSchoolName',
    },
  },
  EducationPeriodBegda: {
    type: DATE,
  },
  EducationPeriodEnda: {
    type: DATE,
  },
  EducationType: {
    type: SELECT_ENUM,
    options: [
      { value: 0, label: <FormattedMessage id="education.type.unknown" /> },
      { value: 1, label: <FormattedMessage id="education.type.university" /> },
      { value: 2, label: <FormattedMessage id="education.type.internship" /> },
      { value: 3, label: <FormattedMessage id="education.type.primary" /> },
      { value: 4, label: <FormattedMessage id="education.type.apprentice" /> },
      { value: 5, label: <FormattedMessage id="education.type.highschool" /> },
    ],
  },
  EducationFurtherInfo: {
    type: TEXT_FIELD,
  },
};



// WEBPACK FOOTER //
// ./src/constants/fields/EmployeeMasterEducation.js